<template>
    <div class="box my-2">
      <div class="col-12 box-header d-flex justify-content-between">
        <span>{{root.descrizione}} - Anno di imposta {{root.annoImposta}}</span>
        <b-button variant="outline-danger flat" size="sm" @click="remove">
          <font-awesome-icon icon="trash-alt" class="mr-2"/>rimuovi modello
        </b-button>
      </div>
      <div>
        <table v-for="(q, ii) in root.quadri" :key="ii" class="table table-striped table-sm small">
          <thead>
            <tr>
              <th class="text-left text-uppercase" colspan="5">Quadro {{q.codice}} - {{q.descrizione}}</th>
            </tr>
            <tr class="text-left">
              <th style="width:3rem">Riga</th>
              <th style="width:4rem">Colonna</th>
              <th>Descrizione</th>
              <th class="text-nowrap" style="width:5rem">Importo</th>
              <th v-if="isPrecompilato" class="text-nowrap" style="width:5rem">Precompilato</th>
              <th class="text-center align-middle" style="width:2rem"><font-awesome-icon icon="question-circle"/></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in q.celle" :key="c.idRcompPilota" class="text-left">
              <td>{{c.riga}}</td>
              <td>{{c.colonna}}</td>
              <td>{{c.descrizione}}</td>
              <td class="pr-2" style="width:5rem" >
                <b-input class="text-right" type="number" style="width:5rem" v-model="c.importo" size="sm" @input="onInput(c)"/>
              </td>
              <td v-if="isPrecompilato" class="pl-auto pr-2" style="width:5rem" >
                <b-input class="text-right" type="number" style="width:5rem" v-model="c.precompilato" size="sm" readonly/>
              </td>
              <td class="text-success text-center cursor-pointer align-middle">
                <font-awesome-icon v-if="c.note" icon="question-circle" color="success" v-b-tooltip.hover :title="c.note"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
import numeral from 'numeral'
import 'numeral/locales'
import jp from 'jsonpath'

export default {
  name: 'ModelloForm',
  props: {
    modello: { type: Object, required: true }
  },
  computed: {
    root () {
      return this.modello
    },
    isPrecompilato () {
      let p = jp.query(this.modello, '$..precompilato', 1)
      return !!p.length
    },
    numeral () {
      return numeral
    }
  },
  methods: {
    remove () {
      this.$emit('remove')
    },
    onInput (cell) {
      if (cell.importo) {
        let v = parseInt(cell.importo)
        if (v < 0) cell.importo = -v
      }
      this.$emit('input', { modello: this.modello, cell })
    },
    formatValuta (value, event) {
      numeral.locale('it')
      // console.log('value.toLocaleString()',value.toLocaleString('it-IT'), numeral(value).format())
      // return value.toLocaleString('it-IT')
      return numeral(value).format()

      // return value
    }
  }
}
</script>

<style lang="stylus" scoped>
.flat {
  border: 0 !important;
}
</style>
